export default "/packs/images/Mamatella~040dce21d005e87ad359232a92ff554a.jpg";